import { render, staticRenderFns } from "./InvestmentCalculator.vue?vue&type=template&id=32d5bf16&scoped=true&"
import script from "./InvestmentCalculator.vue?vue&type=script&lang=js&"
export * from "./InvestmentCalculator.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentCalculator.vue?vue&type=style&index=0&id=32d5bf16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d5bf16",
  null
  
)

export default component.exports